import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import NotificationsList from './NotificationsList';

import styles from './NotificationCenter.scss';

const IGNORE_OUTSIDE_CLICK_CLASSNAME = 'ignore-react-onclickoutside';

export default class NotificationCenter extends Component {
    static propTypes = {
        onGetList: PropTypes.func.isRequired,
        onCount: PropTypes.func.isRequired,
        count: PropTypes.object,
        countProcessing: PropTypes.bool,
        list: PropTypes.array
    };

    state = {
        isListVisible: false
    };

    componentDidMount() {
        const {onCount, onGetList} = this.props;
        onCount();
        onGetList();
    }

    render() {
        const {count, countProcessing, className, role} = this.props;
        const {isListVisible} = this.state;
        const notificationsCount = _.get(count, 'count', 0);

        const containerClass = classnames(styles.container, {
            [styles.disabled]: notificationsCount === 0,
        }, className ? className : '');

        const badgeClass = classnames(styles.badge, {
            [styles.hidden]: !count || countProcessing || notificationsCount === 0
        });

        return (
            <div className={containerClass}>
                <div className={styles.badgeContainer} onClick={::this.toggleVisibility}>
                    <div className={classnames(styles.icon, IGNORE_OUTSIDE_CLICK_CLASSNAME)}/>
                    <div className={badgeClass}>{notificationsCount}</div>
                </div>
                <NotificationsList isVisible={isListVisible} role={role} onClose={::this.toggleVisibility} {...this.props}/>
            </div>

        )
    }

    toggleVisibility() {
        const {list} = this.props;
        if (list.length === 0) {
            return;
        }
        this.setState({isListVisible: !this.state.isListVisible});
    }
}



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationCenter.js